import React from "react";
import {
  Box,
  Typography,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Grid,
  Card,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import { useLocation } from "react-router-dom";
import { printHtml } from "../utils/htmlToPrint";

export default function EntryCard() {

  const location = useLocation();
  const { students } = location.state || [];
  const { entryList } = location.state || [];
  const { note } = location.state || "";
  const temID = "entry-card";
  const toCamelCase = (str) => {
    return str
      ?.toLowerCase()
      .replace(/[^a-zA-Z0-9 ]/g, '')
      .split(' ')
      .map((word, index) =>
        index === 0
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(' ');
  };

  const cell = { border: "1px double #000", px: 1, py: 0.5 };

  // const handlePrint = () => {
  //       setTimeout(() => {
  //           window.print();
  //       }, 100);
  //   };

  return (
    <Box id={temID}
      sx={{
        px: 3,
      }}
    >
      <Grid container spacing={4} justifyContent={'space-around'}>
        {(students || []).map((student, i) => (
          <Grid key={student.id}>
            <Card
              elevation={3}
              sx={{
                width: 400,
                boxShadow: "0 0px 0px rgba(0,0,0,0.2)",
                px: 2
              }}>

              {/* Header */}
              <Box textAlign="center" mb={2}>
                <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: 'nowrap', flexDirection: "row", alignItems: "center" }}>
                  <img
                    src={student?.logoUrl}
                    alt="School Logo"
                    style={{ width: 80, height: 70, marginTop: 10 }}
                  />
                  <Box>
                    <Typography variant="subtitle1" align="center" fontWeight="bold">
                      {toCamelCase(student?.school_name)}
                    </Typography>
                    <Typography variant="caption" align="center">
                      {toCamelCase(student?.school_address)} | Phone: {student?.school_phone || "-"}</Typography>
                  </Box>
                </Box>
                <Divider sx={{ mb: 0.6 }} />
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  color="secondary"
                  textTransform="uppercase"
                  marginBottom={-1}
                >
                  Entry Card
                </Typography>
              </Box>
              <Divider sx={{ mb: 2 }} />
              {/* Student Info */}
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <Box>
                  <Typography variant="body2">
                    <strong>Name:</strong> {student?.name || "..........."}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Father's Name:</strong> {student?.father || ".........."}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Mother's Name:</strong> {student?.mother || "........"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2">
                    <strong>Session:</strong> {student?.academicYear || "........."}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Class:</strong> {student?.standard || "......."} | {student?.section}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Roll No.:</strong> {student?.rollNumber || student?.id}
                  </Typography>
                </Box>
              </Box>
              <Divider sx={{ my: 1 }} />
              {/* Schedule Table */}
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
                Examination Schedule
              </Typography>

              <Table size="small" sx={{ mb: 2 }}>
                <TableHead sx={{ backgroundColor: "#f0f0f0" }}>
                  <TableRow>
                    <TableCell sx={cell}>Date</TableCell>
                    <TableCell sx={cell}>Day</TableCell>
                    <TableCell sx={cell}>Subject</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(entryList || []).map((row, i) => (
                    <TableRow key={i}>
                      <TableCell sx={cell}>
                        {row?.examDate
                          ? new Date(row.examDate).toLocaleDateString("en-GB")
                          : "-"}
                      </TableCell>
                      <TableCell sx={cell}>{row?.days || "-"}</TableCell>
                      <TableCell sx={cell}>{toCamelCase(row?.subject) || "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

              <Typography variant="caption" sx={{ whiteSpace: "pre-wrap" }}>
                <strong>Note:</strong> {toCamelCase(note) || ""}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
      {/* Print Button */}
      <Button
        variant="contained"
        color="secondary"
        startIcon={<PrintIcon />}
        sx={{
          position: "absolute",
          bottom: 20,
          right: 20,
          "@media print": { display: "none" },
        }}
        onClick={() => { printHtml(temID); window.location.reload() }}
      >
        Print Entry Card
      </Button>
    </Box>
  );
}
